import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import '../../styles/components/AdminCard.css';

const AdminCard = ({ title, value, subtitle, icon, color = 'blue', trend, onClick }) => {
  const colorClasses = {
    blue: 'card-blue',
    green: 'card-green',
    purple: 'card-purple',
    yellow: 'card-yellow',
    red: 'card-red',
  };

  return (
    <div className={`admin-card ${colorClasses[color]} ${onClick ? 'clickable' : ''}`} onClick={onClick}>
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        <div className="card-icon">{icon}</div>
      </div>
      <div className="card-content">
        <div className="card-value-wrapper">
          <p className="card-value">{value}</p>
          {trend !== undefined && trend !== null && (
            <span className={`card-trend ${trend >= 0 ? 'trend-up' : 'trend-down'}`}>
              {trend >= 0 ? <TrendingUp size={14} strokeWidth={2.5} /> : <TrendingDown size={14} strokeWidth={2.5} />}
              <span>{Math.abs(trend)}%</span>
            </span>
          )}
        </div>
        {subtitle && <span className="card-subtitle">{subtitle}</span>}
      </div>
    </div>
  );
};

export default AdminCard;
